export default "__VITE_PUBLIC_ASSET__78e2dfc5__"